import React from 'react';

import Input from 'components/shared/Input/Input';

const ModifierForm = ({ formik }) => {
  return (
    <form onSubmit={formik.handleSubmit} className="grid gap-y-4">
      <Input
        id="code"
        name="code"
        label="Code"
        type="text"
        placeholder="Code"
        value={formik?.values?.code}
        error={formik.touched.code && formik?.errors?.code}
        onChange={formik?.handleChange}
      />
      <Input
        id="name"
        name="name"
        label="Name"
        type="text"
        placeholder="Name"
        value={formik?.values?.name}
        error={formik.touched.name && formik?.errors?.name}
        onChange={formik?.handleChange}
      />
    </form>
  );
};

export default ModifierForm;
